import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-12'],
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: anatomy['space-4'],
    cursor: 'pointer',
    color: colors.accentText,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    borderRadius: anatomy.borderRadiusXs,
    border: 'none',
    backgroundColor: 'transparent',
    width: 'fit-content',
    ':hover': {
      backgroundColor: colors.brandGhostBackground,
    },
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['size-8'],
  },
  title: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    fontFamily: fonts.din2014Demi,
    color: colors.primaryText,
    margin: 0,
  },
  titleInput: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    fontFamily: fonts.din2014Demi,
    color: colors.primaryText,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    margin: 0,
    width: '100%',
  },
  editIcon: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: anatomy['space-4'],
    border: 'none',
    background: 'transparent',
    color: colors.secondaryIcon,
    ':hover': {
      color: colors.accentText,
    },
  },
  saveButton: {
    padding: `${anatomy['size-8']} ${anatomy['size-20']}`,
    borderRadius: anatomy['size-8'],
    lineHeight: typography['lineHeightCaption-1'],
    cursor: 'pointer',
    color: colors.primaryText,
    fontSize: typography['fontSizeCaption-1'],
    fontFamily: fonts.din2014Demi,
    background: colors.tertiaryBackground,
  },
  buttonsContainer: {
    display: 'flex',
    gap: anatomy['space-12'],
    alignItems: 'center',
  },
});
